import { ENTER_SUPPORT_CONTEXT, LEAVE_SUPPORT_CONTEXT, LOGOUT } from "../constant";
import { loadSupportContext } from "../supportContextStorage";

const initial = { activeOrg: loadSupportContext() };

export const contextReducer = (state = initial, action) => {
  switch (action.type) {
    case ENTER_SUPPORT_CONTEXT:
      return { ...state, activeOrg: action.payload };
    case LEAVE_SUPPORT_CONTEXT:
    case LOGOUT:
      return { ...state, activeOrg: null };
    default:
      return state;
  }
};
